import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Contato";
import { pageHead, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/contato")({
  head: () =>
    pageHead({
      title: "Contato | Clara Camille Nutricionista",
      description:
        "Entre em contato com a Clara Camille, nutricionista brasileira na Austrália. WhatsApp, e-mail, Instagram e agendamento online.",
      path: "/contato",
      ogDescription:
        "Fale com a Clara Camille pelo WhatsApp, e-mail ou Instagram. Agende sua consulta inicial gratuita.",
      jsonLd: [breadcrumbJsonLd([{ name: "Contato", path: "/contato" }])],
    }),
  component: Page,
});
